/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Api } from '@axiom/ui';

import { ReadLawSchoolsResponseEntity } from './entities/read-law-schools-response-entity';

import { type ReadLawSchoolsResponse } from './dtos/read-law-schools-response';
import { EnvUtil } from '../../utils/env-util';

class LawSchoolApiClass extends Api {
  constructor() {
    super({ domain: EnvUtil.apiEnvoyUrl });
  }

  /*
   * ────────────────────────────────────────────────────────────────────
   *   /lawSchools
   * ────────────────────────────────────────────────────────────────────
   */

  /** Java: LawSchoolsController.getLawSchools — GET /lawSchools */
  readLawSchools({ query }: { query: { "filters"?: { "name"?: string | null; "tags"?: Array<string> | null }; "page"?: number; "search"?: string; "sort"?: string; "order"?: "asc" | "desc" } }) {
    return super.read<ReadLawSchoolsResponse>({
      endpoint: '/lawSchools',
      method: 'GET',
      query,
      schema: { "data": [ReadLawSchoolsResponseEntity] },
    });
  }
}

export const LawSchoolApi = new LawSchoolApiClass();
export type { LawSchoolApiClass };
